<template>
  <GeogebraLegacy
    class="lesson-section-geogebra"
    :file-data="geogebraFileData"
  />
</template>

<script>
import GeogebraLegacy from '../../media/GeogebraLegacy'

export default {
  name: 'LessonSectionGeogebra',
  components: { GeogebraLegacy },
  props: { data: Object },
  computed: {
    geogebraFileData() {
      return this.data.geogebra
    },
  },
}
</script>

<style lang="scss" scoped>
.lesson-section-geogebra {
  display: block;
  max-width: 100%;
  margin: auto;
}
</style>
